const x = {
  c: 'play_from_cursor',
  '[': 'play_from_selection_beg',
  ']': 'play_from_selection_end',
  s: 'stop_playing',
  '.': 'center_and_play_current_span'
};

export { x }
